<script>
import { mapState } from 'vuex';
import { MARKER_ICON } from '@/config/google-maps.config';

export default {
  name: 'GoogleMapsMarker',

  props: {
    marker: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      currentMarker: null,
    };
  },

  computed: {
    ...mapState({
      google: (state) => state.google.api,
      map: (state) => state.google.map,
      selectedMarker: (state) => state.markers.selected,
      selectedListItem: (state) => state.list.selected,
    }),
  },

  mounted() {
    if (this.marker.position) {
      this.placeMarker(this.marker.position);
    }
  },

  watch: {
    selectedListItem() {
      if (this.selectedListItem !== null && this.selectedListItem.id === this.marker.id) {
        this.setSelected();
      }
    },
  },

  methods: {
    placeMarker(position) {
      if (!position) {
        return;
      }

      this.currentMarker = new this.google.maps.Marker({
        position,
        marker: this.marker,
        icon: Object.keys(MARKER_ICON).length ? MARKER_ICON : '',
      });

      this.currentMarker.setMap(this.map);

      this.$store.commit('markers/addVisibleMarkers', this.currentMarker.marker.id);
      this.$store.commit('markers/add', this.currentMarker);

      this.addListeners();
    },

    addListeners() {
      this.currentMarker.addListener('click', () => {
        if (this.currentMarker.marker.id === this.selectedMarker?.marker.id) {
          this.deselect();

          return;
        }

        this.setSelected();
      });
    },

    setSelected() {
      this.$store.commit('markers/select', this.currentMarker);
    },

    deselect() {
      this.$store.commit('markers/deselect');
    },

    toggleMarker(value) {
      if (this.currentMarker.marker.id === this.selectedMarker?.marker.id) {
        this.deselect();
      }

      if (value) {
        this.$store.commit('markers/addVisibleMarkers', this.currentMarker.marker.id);
      } else {
        this.$store.commit('markers/removeVisibleMarkers', this.currentMarker.marker.id);
      }

      this.currentMarker.setVisible(value);
    },
  },

  beforeDestroy() {
    this.currentMarker.setMap(null);
    this.google.maps.event.clearInstanceListeners(this.currentMarker);
  },

  render() {
    return null;
  },
};
</script>
